import React, { Component } from 'react';
import { theme, getTheme } from '../../api/theme';
import Tooltip from '../Tooltip';
import './index.less';
import classNames from 'classnames';

export default class HexagonIcon extends Component {
    constructor(props) {
        super(props);
        this.theme = theme;
        this.state = { theme: '' };
    }

    render() {
        let { backgroundColor, height, minWidth, width, icon, text, iconForTitle, borderRadius, tipInfo={}, isEllipsisRender, maxWidth } = this.props;
        let themeBackgroundColor = backgroundColor? this.hexToHsl(backgroundColor, true) : ''; //NCC-353759
        let hsl = this.hexToHsl(backgroundColor); 
        let { dealHsl, fontColor } = this.hslRule(hsl, true);
        let resultColor = this.formatHsl(dealHsl.h, dealHsl.s, dealHsl.l, true);
        let newBorderRadius = iconForTitle ? '4px' : borderRadius ? height ? parseFloat(height) / 2 : '10px' : '3px';
        let color = backgroundColor ? { color: fontColor } : {};
        let style = {
            backgroundColor: themeBackgroundColor,
            minWidth: minWidth,
            width: width,
            minHeight: height,
            maxWidth:maxWidth,
            border: backgroundColor ? `1px solid ${iconForTitle ? resultColor : themeBackgroundColor}` : 'none',
            ...color,
            borderRadius: newBorderRadius,
        };
        return (
            <Tooltip overlay={tipInfo.overlay}>
                <div className={`hexagon-icon ${icon ? iconForTitle ? 'hexagon-icon-title' : 'hexagon-icon-normal' : ''}`} style={style}>
                    {this.createIcon()}
                    <div className={classNames({ 
                        'hexagon-icon-text': icon || backgroundColor,
                        'hexagon-icon-text-ellipsis': isEllipsisRender,
                        
                    },
                    )} 
                    style={{ borderRadius: newBorderRadius }}>
                        {text}
                    </div>
                </div>
            </Tooltip>
        );
    }

    componentDidMount() {
        let theme = getTheme(false);
        this.setState({ theme });
        this.theme.addListener('themeChange', this.handleThemeChange);
    }

    componentWillUnmount() {
        this.theme.removeListener('themeChange');
    }

    handleThemeChange = theme => {
        this.setState({ theme });
    }

    static defaultProps = {
        backgroundColor: '',
        height: '20px',
        minWidth: '24px',
        icon: '',
        // 标题区标签 传true
        iconForTitle: false,
        text: '审批通过',
        fontColor: '#FFFFFF',
        // 小圆角 传false
        borderRadius: true,
    }

    // 将16进制颜色转换为 HSL 颜色
    hexToHsl = (hex, checkTheme = false) => {
        if(!hex){
            return checkTheme ? '' : {
                h: null,
                s: null,
                l: null,
            };
        }
        hex = hex.substring(1);
        hex = hex.length === 3 ? hex + hex : hex;
        // 将16进制颜色转换为RGB颜色
        const r = parseInt(hex.substring(0, 2), 16) / 255;
        const g = parseInt(hex.substring(2, 4), 16) / 255;
        const b = parseInt(hex.substring(4, 6), 16) / 255;

        // 计算最大值和最小值
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);

        // 计算亮度、饱和度和色相
        const l = (max + min) / 2;
        const s = max === min ? 0 : l > 0.5 ? (max - min) / (2 - max - min) : (max - min) / (max + min);
        const h = max === min ? 0
            : max === r
                ? ((g - b) / (max - min) + (g < b ? 6 : 0)) / 6
                : max === g
                    ? ((b - r) / (max - min) + 2) / 6
                    : ((r - g) / (max - min) + 4) / 6;

        // 将色相、饱和度和亮度转换为HSL颜色
        const hsl = {
            h: Math.round(h * 360),
            s: Math.round(s * 100),
            // 暗黑主题更改传入的背景色  L值改为 22
            l: Math.round(l * 100),
        };
        if(checkTheme){
            return this.state.theme === 'black' ? `hsl(${hsl.h}deg,${hsl.s}%,22%)` : `hsl(${hsl.h}deg,${hsl.s}%,${hsl.l}%)`;
        }
        return hsl;
    }

    hslRule = (hsl, checkTheme = false) => {
        let dealHsl = this.cloneDeep(hsl);
        let l = dealHsl.l;
        // L值大于50减48，小于50加48，
        // 如果L值等于50，则加40，
        // 如果L值在46~49时+30，
        // 如果L值在51~56时-20，
        // L < 40 字体#FFF，大于40#333
        let fontColor = l === null || Number(l) > 40 ? '#333333' : '#FFFFFF';
        let iconColor = l === null || Number(l) > 65 ? '#333333' : '#FFFFFF';
        if(checkTheme){
            fontColor = this.state.theme === 'black' ? '#FFFFFF' : fontColor;
            iconColor = this.state.theme === 'black' ? '#FFFFFF' : iconColor;
        }
        if(l === null){
            dealHsl.l = l;
            return { dealHsl, fontColor, iconColor };
        }
        if (Number(l) >= 46 && Number(l) <= 49) {
            l = l + 30;
        } else if (Number(l) >= 51 && Number(l) <= 56) {
            l = l - 20;
        } else if (Number(l) > 50) {
            l = l - 48;
        } else if (Number(l) < 50) {
            l = l + 48;
        } else if (Number(l) === 50) {
            l = l + 40;
        }
        iconColor = Number(l) > 65 ? '#333333' : '#FFFFFF';
        dealHsl.l = this.state.theme === 'black' ? 22 : l;
        return { dealHsl, fontColor, iconColor };
    }

    calculateGradientRule = (userHsl, dealHsl) => {
        // 用户定义颜色在100-60：dealHsl - 10，userColor -10
        // 用户定义颜色在59-51：
        // dealHsl>26则dealHsl-10,userColor -10,dealHsl<26则dealHsl+10,userColor -10
        // 用户定义颜色在50-30:
        // dealHsl<85则dealHsl-50，userColor -10,dealHsl>85则dealHsl-70，userColor -10，
        // 用户定义在29-0：
        // dealHsl - 40，userColor -5
        const cloneUserHsl = this.cloneDeep(userHsl);
        const cloneDealHsl = this.cloneDeep(dealHsl);
        const userL = cloneUserHsl.l;
        const dealL = cloneDealHsl.l;

        if (userL >= 60) {
            cloneUserHsl.l -= 10;
            cloneDealHsl.l -= 10;
        } else if (userL >= 51) {
            cloneUserHsl.l -= 10;
            cloneDealHsl.l = dealL > 26 ? dealL - 10 : dealL + 10;
        } else if (userL >= 30) {
            cloneUserHsl.l -= 10;
            cloneDealHsl.l = dealL < 85 ? dealL - 50 : dealL - 70;
        } else {
            cloneUserHsl.l -= 5;
            cloneDealHsl.l -= 40;
        }

        return { cloneUserHsl, cloneDealHsl };
    };

    formatHsl = (h, s, l, forTitle= false, blackL) => {

        let hsl = '';
        if(h === null){
            return '';
        }
        if(forTitle){
            // UE要求 调整标签边框颜色的透明度为20%
            if(!isNaN(h)){
                hsl = `hsla(${h}deg,${s}%,${l}%,0.2)`;
            }
            if(this.state.theme === 'black'){
                hsl = `hsla(${h}deg,${s}%,10%,0.2)`;
            }
            return hsl;
        }
        if(!isNaN(h)){
            hsl = `hsl(${h}deg ${s}% ${l}%)`;
        }
        if(this.state.theme === 'black'){
            hsl = `hsl(${h}deg ${s}% ${blackL}%)`;
        }
        return hsl;
    }

    cloneDeep = obj => {
        return JSON.parse(JSON.stringify(obj));
    }

    createIcon = () => {
        let { backgroundColor, icon, iconForTitle } = this.props;
        let themeBackgroundColor = this.hexToHsl(backgroundColor, true);
        let hsl = this.hexToHsl(backgroundColor);
        let { dealHsl, iconColor } = this.hslRule(hsl, true);
        let gradientColor = this.calculateGradientRule(hsl, dealHsl);
        // 渐变色
        let lightColor = this.formatHsl(gradientColor.cloneUserHsl.h, gradientColor.cloneUserHsl.s, gradientColor.cloneUserHsl.l, false, 17);
        let darkColor = this.formatHsl(gradientColor.cloneDealHsl.h, gradientColor.cloneDealHsl.s, gradientColor.cloneDealHsl.l, false, 10);
        let innerStyle = backgroundColor ? { backgroundImage: `linear-gradient(137deg, ${lightColor} 10%, ${darkColor} 100%)` } : {};
        let shadowClassName = this.state.theme === 'black' ? 'icon-miaobiandise icon-miaobiandise-black' : 'icon-miaobiandise';
        if (icon) {
            if (iconForTitle) {
                return (
                    <div className="hexagon-icon-area">
                        <i className={`icon iconfont ${shadowClassName}`} style={{ color: themeBackgroundColor }}></i>
                        <i className="icon iconfont icon-jianbiandise" style={innerStyle}></i>
                        <i className={`icon iconfont icon-${icon} hexagon-icon-area-title`} style={{ color: iconColor }}></i>
                    </div>
                );
            } else {
                let normalBackgroundColor = this.formatHsl(dealHsl.h, dealHsl.s, dealHsl.l, false, 50);
                return (
                    <div className="hexagon-icon-area" style={{ backgroundColor: normalBackgroundColor }}>
                        <i className={`icon iconfont icon-${icon} hexagon-icon-area-normal`} style={{ color: iconColor }}></i>
                    </div>
                );
            }
        } else {
            return null;
        }
    }

}

